import { render, staticRenderFns } from "./editBunkersOnTableRow.vue?vue&type=template&id=f2c27496"
import script from "./editBunkersOnTableRow.vue?vue&type=script&lang=js"
export * from "./editBunkersOnTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports